import { lazy } from 'react'

const OpportunitiesModule = lazy(async () => {
  const { Opportunities } = await import(
    /* webpackChunkName: "opportunities-routes" */ './'
  )

  return {
    default: Opportunities
  }
})
const routes = [
  {
    path: '/opportunities',
    name: 'Opportunities Hub',
    render(props) {
      return <OpportunitiesModule {...props} />
    }
  }
]

export { routes }
